export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImI0ZjM5ZDRkLTczZDUtNGZmNi1hYWQxLTI3OGZiNTIzNGIzYyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.bNHFiMTtLI7jF4YBPULqUzfvg+wneOxx3nAv8HigP/pgC25MwqRp3oLOvfkCfAGVkBH0x1Hwkl7wk/7tOBQt2fljfk/jzXZM1HM/kzZjrZiFgt5RHwRMcRo7VliVLbjvmI7q3w==';
